function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}


import { secondsToISODate } from "../../../../shared/dateHelpers";
import * as entitiesAPI from "../../../../api/entities";
import * as filesAPI from "../../../../api/files";


const SELECT_TYPES = ['select', 'multiselect', 'relationship'];

// eslint-disable-next-line max-statements
const getFormValue = (
suggestion,
entity,
type) =>
{
  let value;

  if (!suggestion || !entity) {
    return value;
  }

  if (suggestion.propertyName === 'title' && entity.title) {
    value = entity.title;
  }

  if (suggestion.propertyName !== 'title' && entity.metadata) {
    const entityMetadata = entity.metadata[suggestion.propertyName];
    value = entityMetadata !== null && entityMetadata !== void 0 && entityMetadata.length ? entityMetadata[0].value : '';

    if (type === 'date' && value) {
      const dateString = secondsToISODate(value);
      value = dateString;
    }

    if (type === 'select' || type === 'multiselect' || type === 'relationship') {
      value = (entityMetadata === null || entityMetadata === void 0 ? void 0 : entityMetadata.map((metadata) => metadata.value)) || [];
    }
  }

  return value;
};

const loadSidepanelData = async ({
  fileId,
  entityId,
  language = 'en'




}) => {
  const [file, entity] = await Promise.all([
  fileId && filesAPI.getById(fileId) || [],
  entitiesAPI.getById({ _id: entityId, language })]
  );

  return _objectSpread(_objectSpread({}, file[0] && { file: file[0] }), {}, { entity: entity[0] });
};

const loadValuesAndSuggestions = async (
value,
suggestions,
language) =>
{
  const entities = await Promise.all(
    value.map(async (sharedId) => {
      const [entity] = await entitiesAPI.getBySharedId({ sharedId, language });
      return entity;
    })
  );

  const suggestionsEntities = await Promise.all(
    suggestions.map(async (sharedId) => {
      const [entity] = await entitiesAPI.getBySharedId({ sharedId, language });
      return entity;
    })
  );

  return [...entities, ...suggestionsEntities].filter((entity) => entity);
};

const handleEntitySave = async (
entity,
property,
metadata,
template,
fieldHasChanged) =>
{
  const propertyName = property === null || property === void 0 ? void 0 : property.name;
  if (!fieldHasChanged || !entity || !propertyName) {
    return undefined;
  }

  let data;

  if (propertyName === 'title' && typeof metadata === 'string') {
    data = { title: metadata };
  } else {
    data = { properties: [{ [propertyName]: metadata }] };
  }

  if ((property === null || property === void 0 ? void 0 : property.type) === 'relationship') {var _template$properties;
    template === null || template === void 0 ? void 0 : (_template$properties = template.properties) === null || _template$properties === void 0 ? void 0 : _template$properties.
    filter(
      (prop) =>
      prop._id !== property._id &&
      prop.content === property.content &&
      prop.type === property.type
    ).
    forEach((prop) => {var _data$properties;
      (_data$properties = data.properties) === null || _data$properties === void 0 ? void 0 : _data$properties.push({ [prop.name]: metadata });
    });
  }

  const entityToSave = entitiesAPI.formatter.update(entity, data);

  return entitiesAPI.save(entityToSave);
};

const coerceValue = async (
propertyType,
text,
language = 'en') =>
{
  if (propertyType === 'date' && !Number.isNaN(text === null || text === void 0 ? void 0 : text.valueOf())) {
    return entitiesAPI.coerceValue(text, 'date', language);
  }

  if (propertyType === 'numeric' && typeof text === 'string') {
    return entitiesAPI.coerceValue(text.trim(), 'numeric', language);
  }

  return undefined;
};

const getPropertyNameFromExtractPair = (extractorPair) =>
extractorPair.substring(extractorPair.indexOf('-') + 1, extractorPair.length);

const getTemplateFromExtractPair = (extractorPair) =>
extractorPair.substring(0, extractorPair.indexOf('-'));

export {
  SELECT_TYPES,
  coerceValue,
  getFormValue,
  loadSidepanelData,
  loadValuesAndSuggestions,
  handleEntitySave,
  getPropertyNameFromExtractPair,
  getTemplateFromExtractPair };